import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-advanced',
    templateUrl: './advanced.component.html',
    styles: [],
    encapsulation: ViewEncapsulation.None,
})

export class AdvancedComponent implements OnInit {
     @Input() form: FormGroup;
    ngOnInit(): void {
    }
}
